// src/components/SellOfferPage/SellOfferPage.jsx

import React, { useEffect, useMemo, useState } from "react";

import Navbar from "../Navbar/Navbar";

import api from "../Axios/axios";

import "./SellOfferPage.scss";

const STAR_CRANE_COMPANY_ID = "b6af2c6e-168e-447f-8b85-08ddb5506453";

const SALES_OFFER_BANK_INFO_PREFIX = "__BANK_INFO__:";

const DEFAULT_SALES_BANK_INFO = [
  "Kuveyt Türk IBAN (USD): TR55 0020 5000 0996 2993 1001 01",
  "Vakıf Bank IBAN (USD): TR93 0001 5001 5800 7341 7436 77",
  "STAR CRANE İŞ MAKİNELERİ İTHL. İHR. A. Ş.",
];

const DEFAULT_SALES_MACHINE_SPECS = [
  { label: "Ürün", value: "" },
  { label: "Marka ve Model", value: "" },
  { label: "İmal Yılı", value: "" },
  { label: "Mast Boyut", value: "" },
  { label: "Mast Adet", value: "" },
  { label: "Max Kaldırma Kapasite", value: "" },
  { label: "Bom Uzunluğu", value: "" },
  { label: "Bom Ucu Kapasite", value: "" },
  { label: "Serbest Duruş Yükseklik", value: "" },
  { label: "Kaldırma", value: "" },
  { label: "Çevirme", value: "" },
  { label: "Sürüş", value: "" },
  { label: "Zemin Tipi", value: "" },
  { label: "Menşei", value: "" },
];

const normalizeSalesMachineSpecs = (rows = [], selectedMachineName = "") => {
  const read = (...labels) => {
    const found = rows.find((row) =>
      labels.some((label) => (row.label || "").trim().toLowerCase() === label.toLowerCase())
    );
    return found?.value || "";
  };

  return DEFAULT_SALES_MACHINE_SPECS.map((spec) => {
    let value = read(spec.label);

    if (!value && spec.label === "Ürün") value = selectedMachineName || read("Makine", "Ürün");
    if (!value && spec.label === "Marka ve Model") {
      value = [read("Marka"), read("Model")].filter(Boolean).join(" ").trim() || read("Marka ve Model");
    }
    if (!value && spec.label === "İmal Yılı") value = read("Model Yılı", "İmal Yılı");
    if (!value && spec.label === "Max Kaldırma Kapasite") value = read("Maks. Kapasite", "Max Kaldırma Kapasite");
    if (!value && spec.label === "Serbest Duruş Yükseklik") value = read("Serbest Yükseklik (Kanca Altı)", "Serbest Duruş Yükseklik");
    if (!value && spec.label === "Menşei") value = read("Menşe", "Menşei");

    return { ...spec, value };
  });
};


export default function SellOfferPage() {
  const [isSavingOffer, setIsSavingOffer] = useState(false);

  // --- Firms ---

  const sellerId = STAR_CRANE_COMPANY_ID;

  const [sellerInfo, setSellerInfo] = useState({

    companyName: "", taxNo: "", address: "", contact: "", phone: "", email: ""

  });



  const [buyerInfo, setBuyerInfo] = useState({

    companyName: "", taxOffice: "", taxNo: "", address: "", contact: "", phone: "", email: ""

  });



  // --- Teklif türü: yalnız açıklamaları doldurmak için kullanılıyor ---

  const [offerType, setOfferType] = useState("SalesOffer");



  // --- Makine şablonu ---

  const [machineOptions, setMachineOptions] = useState([]);

  const [selectedMachineId, setSelectedMachineId] = useState("");

  const [selectedMachineName, setSelectedMachineName] = useState("");



  // --- Dinamik makine satırları ---

  const [machineSpecs, setMachineSpecs] = useState(DEFAULT_SALES_MACHINE_SPECS);



  // --- Fiyat ---

  const [pricing, setPricing] = useState({ currency: "USD", quantity: 1, price: "" });

  const getApiErrorMessage = (error, fallback) => {
    const data = error?.response?.data;

    if (Array.isArray(data?.messages) && data.messages.length) return data.messages.join(" ");
    if (Array.isArray(data?.Messages) && data.Messages.length) return data.Messages.join(" ");
    if (data?.message) return data.message;
    if (data?.Message) return data.Message;
    if (typeof data === "string" && data.trim()) return data;

    return fallback;
  };



  // --- Açıklamalar ---

  const [bankInfoLines, setBankInfoLines] = useState(DEFAULT_SALES_BANK_INFO);

  const [details, setDetails] = useState([

    "•Gümrük Tarife Kodu: 8426200000",

    "•Üretim Standardı: Kule vinç, CE standartlarına uygun olarak üretilmiştir.",

    "•Sevkiyat Süresi: Ödeme sonrası 15 gün içinde ilk gemiye rezervasyon yapılması garanti edilmektedir. Tahmini gemi geliş süresi 45-60 gündür.",

    "•Teslim Şekli: CIF Gümrük Teslim",

    "•Ödeme Şartı: %100 Peşin Ödeme.",

    "•Çalışması için zorunlu olanlar dışında aksam ve aksesuarlar bulunmamaktadır.",

    "•Proforma Geçerlilik Süresi: 7 gündür (Nakliye sebebiyle haftalık fiyat kontrol edilmesi gerekmektedir.)",

  ]);



  // ---- İlk veriler ----

  useEffect(() => {
    api.get("/Machine")

      .then((res) => setMachineOptions(res?.data?.data || []))

      .catch(() => setMachineOptions([]));

  }, []);



  // ---- Teklif türüne göre açıklamaları getir ----

  useEffect(() => {

    api.get("/Description", { params: { type: offerType } })

      .then((res) => {

        const arr = (res?.data?.data || [])

          .map((d) => d.name || d.description)

          .filter(Boolean);

        if (arr.length) setDetails(arr);

      })

      .catch(() => { });

  }, [offerType]);



  // ---- Firma seçilirse bilgilerini doldur ----

  useEffect(() => {

    if (!sellerId) return;

    api.get(`/Company/GetById?id=${sellerId}`).then((res) => {

      const d = res?.data?.data || {};

      setSellerInfo({

        companyName: d.name || "STAR KULE VİNÇ VE İŞ MAKİNELERİ KİRALAMA ANONİM ŞİRKETİ",

        taxNo: d.taxNo || "",

        address: d.address || "",

        contact: d.authorizedPerson1 || "",

        phone: d.phoneNumber1 || "",

        email: d.email || "",

      });

    });

  }, [sellerId]);



  // ---- Makine seçimi ----

  useEffect(() => {

    if (!selectedMachineId) {

      setSelectedMachineName("");

    } else {

      api.get(`/Machine/${selectedMachineId}`)

        .then((res) => {

          const d = res?.data?.data;

          if (!d) return;

          setSelectedMachineName(d.model || "");

          const rows = (d.machineTemplates || []).map((t) => ({

            label: (t.title || "").trim().replace(/\s*:\s*$/, ""),

            value: t.description || "",

          }));

          setMachineSpecs(rows.length ? normalizeSalesMachineSpecs(rows, d.model || "") : normalizeSalesMachineSpecs([], d.model || ""));

        })

        .catch(() => { });

    }

  }, [selectedMachineId]);



  // ---- Helpers ----

  const priceNumber = useMemo(

    () => Number(String(pricing.price).replace(/\./g, "").replace(/,/g, ".")) || 0,

    [pricing.price]

  );

  const quantityNumber = Number(pricing.quantity || 0);



  const addSpecRow = () => setMachineSpecs((arr) => [...arr, { label: "", value: "" }]);

  const removeSpecRow = (idx) => setMachineSpecs((arr) => arr.filter((_, i) => i !== idx));



  const getSpecVal = (label) =>

    machineSpecs.find(s => (s.label || "").toLowerCase() === label.toLowerCase())?.value?.trim() || "";



  const buildMachineString = () => {

    if (selectedMachineName) return selectedMachineName;

    const brand = getSpecVal("Marka");

    const model = getSpecVal("Model");

    const name = [brand, model].filter(Boolean).join(" ").trim();

    return name || "Makine";

  };



  // ---- Kaydet: firma seçimi opsiyonel ----

  const saveOffer = () => {
    if (isSavingOffer) return;

    // En azından satıcı için bir seçim ya da manuel bilgi girilmiş olmalı

    const buyerManualFilled = String(buyerInfo.companyName || "").trim();



    if (!sellerId) {

      alert("Satıcı firmayı listeden seçmelisiniz.");

      return;

    }

    if (!buyerManualFilled) {

      alert("Alıcı firma adını girin.");

      return;

    }

    if (!quantityNumber || quantityNumber < 1) { alert("Adet giriniz!"); return; }

    if (!priceNumber || priceNumber <= 0) { alert("Fiyat giriniz!"); return; }



    // Temel payload

    const payload = {

      // Backend teklif PDF'i için kayıtlı satıcı firma ID'si bekliyor.

      rentingCompanyId: sellerId,



      // Alıcı bilgileri (ID olsun ya da olmasın metin alanlarından geliyor)

      buyerCompany: buyerInfo.companyName,

      buyerCompanyTaxOffice: buyerInfo.taxOffice,

      buyerCompanyTaxNo: buyerInfo.taxNo,

      buyerCompanyName: buyerInfo.companyName,

      buyerCompanyAddress: buyerInfo.address,

      buyerCompanyAuthorizedPerson: buyerInfo.contact,

      buyerCompanyAuthorizedPersonPhone: buyerInfo.phone,

      buyerCompanyAuthorizedPersonEmail: buyerInfo.email,



      machine: buildMachineString(),

      machineTemplates: machineSpecs.map(s => ({

        title: s.label || "",

        description: s.value || ""

      })),



      currency: pricing.currency,

      piece: quantityNumber,

      price: priceNumber,



      // Teklif türüne göre doldurulmuş açıklamalar

      descriptions: [
        ...details.map(d => ({ description: d })),
        ...bankInfoLines
          .filter((line) => String(line || "").trim().length > 1)
          .map((line) => ({ description: `${SALES_OFFER_BANK_INFO_PREFIX}${line}` }))
      ]

    };



    setIsSavingOffer(true);
    api.post("/SalesOffer", payload)

      .then(() => alert("Satış teklifi kaydedildi!"))

      .catch((error) => {
        console.error("Satış teklifi kaydedilemedi:", error?.response?.data || error);
        alert(getApiErrorMessage(error, "Kayıt sırasında hata oluştu."));
      })
      .finally(() => setIsSavingOffer(false));

  };



  return (

    <>

      <Navbar />

      <div className="sell-offer-page">

        <h2>Satış Teklifi</h2>



        <div className="offer-form">



          <div className="form-row">

            <label>Teklifi Veren Firma</label>

            <input value={sellerInfo.companyName} onChange={(e) => setSellerInfo({ ...sellerInfo, companyName: e.target.value })} />

          </div>

          <div className="form-row multi">

            <div>

              <label>Vergi No</label>

              <input value={sellerInfo.taxNo} onChange={(e) => setSellerInfo({ ...sellerInfo, taxNo: e.target.value })} />

            </div>

            <div>

              <label>Adres</label>

              <input value={sellerInfo.address} onChange={(e) => setSellerInfo({ ...sellerInfo, address: e.target.value })} />

            </div>

            <div>

              <label>Yetkili</label>

              <input value={sellerInfo.contact} onChange={(e) => setSellerInfo({ ...sellerInfo, contact: e.target.value })} />

            </div>

            <div>

              <label>Tel</label>

              <input value={sellerInfo.phone} onChange={(e) => setSellerInfo({ ...sellerInfo, phone: e.target.value })} />

            </div>

            <div>

              <label>Email</label>

              <input value={sellerInfo.email} onChange={(e) => setSellerInfo({ ...sellerInfo, email: e.target.value })} />

            </div>

          </div>







          {/* Alıcı Firma */}

          <div className="form-row manual-company-row">

            <label>Alıcı Firma (Teklif Verilen)</label>

            <input
              value={buyerInfo.companyName}
              onChange={(e) => setBuyerInfo({ ...buyerInfo, companyName: e.target.value })}
              placeholder="Firma adı girin"
            />

          </div>



          <div className="form-row multi">

            <div>

              <label>Vergi Dairesi</label>

              <input value={buyerInfo.taxOffice} onChange={(e) => setBuyerInfo({ ...buyerInfo, taxOffice: e.target.value })} />

            </div>

            <div>

              <label>Vergi No</label>

              <input value={buyerInfo.taxNo} onChange={(e) => setBuyerInfo({ ...buyerInfo, taxNo: e.target.value })} />

            </div>

            <div>

              <label>Adres</label>

              <input value={buyerInfo.address} onChange={(e) => setBuyerInfo({ ...buyerInfo, address: e.target.value })} />

            </div>

            <div>

              <label>Yetkili</label>

              <input value={buyerInfo.contact} onChange={(e) => setBuyerInfo({ ...buyerInfo, contact: e.target.value })} />

            </div>

            <div>

              <label>Tel</label>

              <input value={buyerInfo.phone} onChange={(e) => setBuyerInfo({ ...buyerInfo, phone: e.target.value })} />

            </div>

            <div>

              <label>Email</label>

              <input value={buyerInfo.email} onChange={(e) => setBuyerInfo({ ...buyerInfo, email: e.target.value })} />

            </div>

          </div>



          {/* Makine Şablonu (opsiyonel) */}

          <div className="form-row">

            <label>Makine Şablonu (Opsiyonel)</label>

            <select

              value={selectedMachineId}

              onChange={(e) => setSelectedMachineId(e.target.value)}

            >

              <option value="">Seçin...</option>

              {machineOptions.map((m) => (

                <option key={m.id} value={m.id}>{m.model}</option>

              ))}

            </select>

          </div>



          {/* Dinamik Makine Bilgileri */}

          <h3>Makine Bilgileri</h3>

          <div className="specs-table">

            <div className="specs-head">

              <div>Başlık</div>

              <div>Açıklama</div>

              <div className="specs-actions-col">Sil</div>

            </div>

            {machineSpecs.map((row, idx) => (

              <div className="specs-row" key={idx}>

                <input

                  className="spec-input"

                  placeholder="Örn: Marka"

                  value={row.label}

                  onChange={(e) => {

                    const v = e.target.value;

                    setMachineSpecs((arr) => {

                      const copy = [...arr];

                      copy[idx] = { ...copy[idx], label: v };

                      return copy;

                    });

                  }}

                />

                <input

                  className="spec-input"

                  placeholder="Örn: Turkish Tower Cranes"

                  value={row.value}

                  onChange={(e) => {

                    const v = e.target.value;

                    setMachineSpecs((arr) => {

                      const copy = [...arr];

                      copy[idx] = { ...copy[idx], value: v };

                      return copy;

                    });

                  }}

                />

                <button

                  type="button"

                  className="remove-btn"

                  onClick={() => removeSpecRow(idx)}

                  title="Satırı sil"

                >

                  -

                </button>

              </div>

            ))}

            <button type="button" className="btn-small" onClick={addSpecRow}>

              + Satır Ekle

            </button>

          </div>



          {/* Fiyat */}

          <h3>Fiyat</h3>

          <div className="form-row multi">

            <div>

              <label>Para Birimi</label>

              <select

                value={pricing.currency}

                onChange={(e) => setPricing({ ...pricing, currency: e.target.value })}

              >

                <option>USD</option>

                <option>EUR</option>

                <option>TRY</option>

              </select>

            </div>

            <div>

              <label>Adet</label>

              <input

                type="number"

                min="1"

                value={pricing.quantity}

                onChange={(e) => setPricing({ ...pricing, quantity: Number(e.target.value) })}

                placeholder="Örn: 1"

              />

            </div>

            <div>

              <label>Fiyat</label>

              <input

                value={pricing.price}

                onChange={(e) => setPricing({ ...pricing, price: e.target.value })}

                placeholder="Örn: 250000"

              />

            </div>

          </div>

          {/* Teklif Türü */}

          <div className="form-row">

            <label>Teklif Türü</label>

            <select value={offerType} onChange={(e) => setOfferType(e.target.value)}>

              <option value="SalesOffer">Peşin</option>

              <option value="SalesLeasingOffer">Leasing</option>

            </select>

          </div>



          {/* Açıklamalar */}

          <h3>Diğer Bilgiler - Açıklama</h3>

          {details.map((d, i) => (

            <div className="form-row details-container" key={i}>

              <input

                className="detail-input"

                value={d}

                onChange={(e) => {

                  const v = e.target.value;

                  setDetails((arr) => {

                    const c = [...arr];

                    c[i] = v;

                    return c;

                  });

                }}

              />

              <button

                type="button"

                className="remove-btn"

                onClick={() => setDetails((arr) => arr.filter((_, idx) => idx !== i))}

              >

                Kaldır

              </button>

            </div>

          ))}

          <button

            type="button"

            className="btn-small"

            onClick={() => setDetails((d) => [...d, ""])}

          >

            + Detay Ekle

          </button>

          <div className="bank-info-box">

            <strong>Banka Bilgileri;</strong>

            {bankInfoLines.map((line, index) => (

              <input

                key={index}

                value={line}

                onChange={(e) => {

                  const value = e.target.value;

                  setBankInfoLines((items) => {

                    const next = [...items];

                    next[index] = value;

                    return next;

                  });

                }}

              />

            ))}

          </div>



          <div className="actions">

            <button className="btn-primary" onClick={saveOffer} disabled={isSavingOffer}>
              {isSavingOffer ? "Kaydediliyor..." : "Kaydet"}
            </button>

          </div>

        </div>



        {/* Özet */}

        <div className="summary">

          <h4>Özet</h4>

          <ul>

            <li><strong>Tür:</strong> {offerType === "SalesOffer" ? "Satış" : "Leasing"}</li>

            <li>

              <strong>Satıcı:</strong>{" "}

              STAR KULE VİNÇ VE İŞ MAKİNELERİ KİRALAMA ANONİM ŞİRKETİ

            </li>

            <li>

              <strong>Alıcı:</strong>{" "}

              {buyerInfo.companyName || "Elle"}

            </li>

            <li><strong>Adet / Fiyat:</strong> {pricing.quantity} adet • {priceNumber.toLocaleString("tr-TR")} {pricing.currency}</li>

            <li><strong>Makine:</strong> {buildMachineString()}</li>

            <li><strong>Makine Satırları:</strong> {machineSpecs.length} adet</li>

          </ul>

        </div>

      </div>

    </>

  );

}
